import type { GetProductInfoResponse } from '../../../shared/api/generated'

type ProductCharacteristics = Pick<GetProductInfoResponse, 'stringCriteria' | 'numberCriteria'>

export function groupProductCharacteristics(product: ProductCharacteristics) {
  const groups = new Map<string, Map<string, { title: string; values: string[] }>>()
  for (const criterion of [...(product.stringCriteria ?? []), ...(product.numberCriteria ?? [])]) {
    const value = criterion.value
    if (value === undefined || value === null) continue
    if (typeof value === 'number' && !Number.isFinite(value)) continue
    const text = String(value).trim()
    if (!text) continue

    const groupName = criterion.name?.trim() || ''
    const title = criterion.propertyName?.trim() || groupName || 'Характеристика'
    const key = criterion.criterionId !== undefined ? String(criterion.criterionId) : title
    let group = groups.get(groupName)
    if (!group) {
      group = new Map()
      groups.set(groupName, group)
    }
    const row = group.get(key)
    if (row) {
      if (!row.values.includes(text)) row.values.push(text)
    } else group.set(key, { title, values: [text] })
  }
  return [...groups].map(([name, rows]) => ({
    name,
    rows: [...rows].map(([key, row]) => ({ key, ...row })),
  }))
}
